module.exports = __webpack_public_path__ + "753882e112aa3cd5d4aa402497902bb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/velikonocni-tabor-4.jpg
// module id = 1204
// module chunks = 0